import L from "leaflet";

export const DEPOTS = [
  { name: "Panaji", lat: 15.4909, lng: 73.8278 },
  { name: "Margao", lat: 15.2832, lng: 73.9862 },
  { name: "Mapusa", lat: 15.5912, lng: 73.8082 },
  { name: "Vasco", lat: 15.3981, lng: 73.8113 },
  { name: "Ponda", lat: 15.4027, lng: 74.0080 },
  { name: "Canacona", lat: 14.9959, lng: 74.0521 },
];

export const STATUS_COLOR = {
  "Available":"#22C55E","On Trip":"#1E3A8A","Maintenance":"#F97316",
  "Breakdown":"#EF4444","Charging":"#06B6D4","Reserved":"#8B5CF6","Scrapped":"#64748B",
};

// CARTO's raster basemaps (the old light_all style used here) now require a
// paid/signed-up API key and are being deprecated by CARTO themselves. Esri's
// World_Light_Gray_Base gives the same light/greyish cartographic look, is
// still free with no key required, and needs no account signup. Note Esri's
// REST tile path is z/y/x (row before column), not the usual z/x/y.
export const TILE_URL = "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";
export const TILE_ATTR = '&copy; Esri &mdash; Esri, DeLorme, NAVTEQ';

const cache = {};
export function busIcon(status, size = 28) {
  const color = STATUS_COLOR[status] || "#64748B";
  const key = `${status}-${size}`;
  if (cache[key]) return cache[key];
  const html = `<div style="display:flex;align-items:center;justify-content:center;width:${size}px;height:${size}px;border-radius:50%;background:${color};box-shadow:0 2px 6px rgba(0,0,0,0.25),0 0 0 2px #fff;color:#fff;transform:translate(-50%,-50%);">
    <svg xmlns="http://www.w3.org/2000/svg" width="${size*0.6}" height="${size*0.6}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="6" width="18" height="12" rx="2"/>
      <path d="M3 12h18"/>
      <circle cx="7.5" cy="18.5" r="1.5"/>
      <circle cx="16.5" cy="18.5" r="1.5"/>
      <path d="M6 6V4M18 6V4"/>
    </svg>
  </div>`;
  const icon = L.divIcon({ className: "ktcl-bus-marker", html, iconSize: [size, size], iconAnchor: [0, 0] });
  cache[key] = icon;
  return icon;
}

export function depotIcon() {
  if (cache.depot) return cache.depot;
  const html = `<div style="display:flex;align-items:center;justify-content:center;width:24px;height:24px;background:#0F1A3D;color:#fff;border-radius:4px;font-weight:900;font-size:11px;box-shadow:0 2px 4px rgba(0,0,0,0.3);transform:translate(-50%,-50%);">D</div>`;
  cache.depot = L.divIcon({ className: "ktcl-depot-marker", html, iconSize: [24,24], iconAnchor:[0,0] });
  return cache.depot;
}

export function pulseBusIcon(status, size = 32) {
  const color = STATUS_COLOR[status] || "#EF4444";
  const html = `<div style="position:relative;transform:translate(-50%,-50%);width:${size}px;height:${size}px;">
    <div style="position:absolute;inset:0;border-radius:50%;background:${color};opacity:0.55;animation:ktcl-pulse 1.4s ease-out infinite;"></div>
    <div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;border-radius:50%;background:${color};box-shadow:0 0 0 2px #fff;color:#fff;">
      <svg width="${size*0.55}" height="${size*0.55}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="18" height="12" rx="2"/><path d="M3 12h18"/><circle cx="7.5" cy="18.5" r="1.5"/><circle cx="16.5" cy="18.5" r="1.5"/></svg>
    </div></div>`;
  return L.divIcon({ className: "ktcl-bus-marker", html, iconSize:[size,size], iconAnchor:[0,0] });
}
